import { Icon } from "@phosphor-icons/react";
import Card from "./Card";
import Typography from "./Typography";

type DataFieldCardProps = {
    title: string;
    value: string | number;
    icon: Icon;
};

const DataFieldCard = ({ title, value, icon: Icon }: DataFieldCardProps) => {
    return (
        <Card
            variant="success"
            className="flex-1 p-6 pt-4 overflow-hidden self-start"
        >
            <div className="pb-1 border-b border-inherit flex items-center justify-between">
                <Typography variant="title-small" component="h3">
                    {title}
                </Typography>
                <Icon weight="fill" size={20} className="text-soft-green-80" />
            </div>
            <div className="pt-2 flex items-center">
                <Typography
                    variant="display-small"
                    component="span"
                    className="ml-2 text-soft-green-80 max-[1080px]:!text-[1.75rem]"
                >
                    <span
                        dangerouslySetInnerHTML={{ __html: value.toString() }}
                    />
                </Typography>
            </div>
        </Card>
    );
};

export default DataFieldCard;
